import { render, staticRenderFns } from "./NewSwapFromTemplate.vue?vue&type=template&id=00d7f3c8&"
import script from "./NewSwapFromTemplate.vue?vue&type=script&lang=js&"
export * from "./NewSwapFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports